import { Translate } from "@/redux/modules/value/translations/translations.provider";

export const splitPrice = (price: number, fractionDigits = 2) =>
    price.toFixed(fractionDigits).toString().split(".");

type FormatPrice = (
    price?: number,
    formatOptions?: {
        currency?: boolean;
        zeroAsDash?: boolean;
    } & (
        | {
              freeLabel?: false;
          }
        | {
              freeLabel: true;
              t: Translate;
          }
    )
) => string;

export const formatPrice: FormatPrice = (price = 0, formatOptions = {}) => {
    const {
        currency = false,
        zeroAsDash = false,
        ...freeProps
    } = formatOptions;

    if (freeProps.freeLabel && price === 0) {
        return freeProps.t("general.product.free");
    }

    let formatted = price.toFixed(2).toString().replace(".", ",");

    if (currency) {
        formatted = `€${formatted}`;
    }

    if (zeroAsDash) {
        formatted = formatted
            // replace trailing zeros after a comma
            .replace(/,0+$/, ",-");
    }

    return formatted;
};

export function formatPriceNoRounding(price = 0, fractionDigits = 2) {
    return (
        parseInt(`${price * 10 ** fractionDigits}`, 10) /
        10 ** fractionDigits
    ).toFixed(fractionDigits);
}
